export var FeatureSections;
(function (FeatureSections) {
    FeatureSections["EXTERIOR"] = "exterior";
    FeatureSections["INTERIOR"] = "interior";
    FeatureSections["ACCESSORY_PACK"] = "accessoryPack";
    FeatureSections["ACCESSORY"] = "accessory";
    FeatureSections["SERVICE_PLAN"] = "servicePlan";
})(FeatureSections || (FeatureSections = {}));
//# sourceMappingURL=FeatureSections.js.map